export const MUNICIPAL_PROPERTY_FEATURE_FLAG_ID = "enable-liegenschaften";
